<script module lang="ts">
  import type { Snippet } from 'svelte';
  import type { HTMLAttributes } from 'svelte/elements';

  export interface Props extends HTMLAttributes<HTMLDivElement> {
    children?: Snippet;
    /** Buttons at the right end of the line (page settings) — no wrapper of one's own. */
    end?: Snippet;
  }
</script>

<script lang="ts">
  import { LayerHandler } from '../../handlers/LayerHandler';

  const { children, end, class: className, ...toNext }: Props = $props();

  // -
  const Layer = new LayerHandler();
  const MyLayer = Layer.upContentLayer();
</script>

<div {...toNext} class={['buttonLine', className, 'contentLayer', `contentLayer${String(MyLayer)}`]}>
  {@render children?.()}
  {#if end}
    <span class="buttonLineEnd">
      {@render end()}
    </span>
  {/if}
</div>

<style lang="scss">
  @use '../../../styles/display';

  .buttonLine {
    @include display.block;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    gap: var(--outset-abs-half);
    margin-top: var(--outset-abs);
    justify-content: flex-start;
  }

  .buttonLineEnd {
    display: flex;
    align-items: center;
    gap: var(--outset-abs-half);
    margin-left: auto;
  }
</style>
